export default "__VITE_PUBLIC_ASSET__abb2d9ee__"